// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"87330772","453":"92776f66","732":"a3f61e4b","977":"021fbe0e"}[chunkId] + ".chunk.js";
};